import request from '../index'

/**
 * 产品相关API
 */
const productApi = {
  /**
   * 获取产品列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @returns {Promise}
   */
  getProductList(params) {
    return request({
      url: '/biz/product',
      method: 'get',
      params
    })
  },
  /**
   * 获取溯源码列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @param {string} params.batch - 生产批次
   * @returns {Promise}
   */
  getCodeList(params) {
    return request({
      url: '/biz/code',
      method: 'get',
      params
    })
  },
  /**
   * 获取主体信息列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @returns {Promise}
   */
  getSubjectList(params) {
    return request({
      url: '/biz/subject',
      method: 'get',
      params
    })
  },
  /**
   * 获取检测报告列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @param {string} params.batch - 生产批次（可选）
   * @returns {Promise}
   */
  getReportList(params) {
    return request({
      url: '/biz/report',
      method: 'get',
      params
    })
  },
  /**
   * 获取产地信息列表
   * @param {Object} params - 请求参数
   * @param {number} params.pageNum - 当前页
   * @param {number} params.pageSize - 分页数
   * @param {string} params.batch - 生产批次（可选）
   * @returns {Promise}
   */
  getPlaceList(params) {
    return request({
      url: '/biz/place',
      method: 'get',
      params
    })
  },
   getWeather(params) {
    return request({
      url: '/api/weather/now',
      method: 'get',
      params
    })
  }
}

export default productApi